import { ApiError } from "@shared/types";

export function isApiError(error: any): error is ApiError {
  return (error as ApiError).body !== undefined;
}
